import {mapGetters} from 'vuex'
import { EventBusNotification } from '@/components/EventBusNotification.js'
//import Vue from 'vue';
//import CONFIG from '@/constants/config.js';

export var teamMixin = {
  mixins:[EventBusNotification],
  watch: { 
  },
  
  data(){
    return{
      hasOpenTeamLeaderRequestNotification:false
    }
  },
  computed: {
    ...mapGetters('events',['selectedEventId','selectedEvent','hasSelectedEvent','team','teamId','teamMembers','teamLeader','teamMemberById']),
    ...mapGetters('settings',['userId']),
    ...mapGetters('websocket',['isOnline','hasLeaderChangeRequest','leaderChangeRequest']),

    teamLeaderId(){
      return this.teamLeader?this.teamLeader.id:null;
    },
    
    useMasterSlave(){
      return (this.selectedEvent)?this.selectedEvent.master_slave:false;
    },
    isTeamLeader(){
      return this.teamLeaderId== this.userId
    },
    //Is TeamLeader in Single Mode or TeamLeader in Multiplayer Mode
    isTeamLeaderInMasterSlaveModeOrIsSingleMode(){
      return (!this.useMasterSlave || (this.useMasterSlave && this.isTeamLeader));
    },
    isTeamLeaderInMasterSlaveMode(){
      return (this.useMasterSlave && this.isTeamLeader);
    },
    isSlaveInMasterSlaveMode(){
      return (this.useMasterSlave && !this.isTeamLeader);
    }
  },
  methods: {
    createTeamLeaderChange(){
      this.$store.commit("websocket/START_TEAMLEADER_CHANGE_REQUEST");
    },
    resetTeamLeaderChange(){
      this.$store.commit("websocket/CLEAR_TEAMLEADER_CHANGE_REQUEST");
    },
    requestTeamleaderChange(){
      if(this.useMasterSlave){
        this.createTeamLeaderChange();
        this.$websocket.broadcast.leaderChangeRequest(this.userId);
        let teamMember=this.teamMemberById(this.teamLeaderId);
        if(teamMember){
          EventBusNotification.$emit('notify',this.$t('app_team_master_requested_change',{seconds:process.env.VUE_APP_TEAMLEADER_RESPONSE_TIME,leader_name:teamMember.name}),null,null,(parseInt(process.env.VUE_APP_TEAMLEADER_RESPONSE_TIME)+1),0,null,null,()=>{
            //onOutOfTime response
            this.notifyTeamleaderChanged(this.userId);
          });
          console.log('hasOpenTeamLeaderRequestNotification requestTeamleaderChange:',this.hasOpenTeamLeaderRequestNotification);
        }
      }
    },
    sendTeamleaderChangeAbort(){
      if(this.useMasterSlave){
        this.$websocket.broadcast.leaderChangeRequest(this.userId,true);
      }
    },
    notifyTeamleaderChanged(personId,confirmByUserResult=true){
      try{
          if(this.useMasterSlave){
            if(confirmByUserResult){
              this.setTeamLeader(personId).then(()=>{
                this.$websocket.broadcast.leaderChange(personId,confirmByUserResult);
                let teamMember=this.teamMemberById(personId);
                if(teamMember){
                  let label = (personId==this.userId)?this.$t('app_team_master_changed_to_me'):this.$t('app_team_master_changed_to',{leader_new_name:teamMember.name});
                  EventBusNotification.$emit('notify',label);
                }
                this.resetTeamLeaderChange();
              }).catch(ex=>{
                EventBusNotification.$emit('notify',this.$t('noInternetConnectionOk'));
                console.log(ex);
              });
            }else{
              this.$websocket.broadcast.leaderChange(personId,confirmByUserResult);
            }

            this.hasOpenTeamLeaderRequestNotification=false;
          }
        }catch(ex){
          console.log(ex);
        }
    },
    notifyTeamPhotoChanged(){
      try{
        this.$websocket.broadcast.teamPhotoChange(this.userId);
      }catch(ex){
        console.log(ex);
      }
    },
    notifyTeamNameChanged(){
      try{
        this.$websocket.broadcast.teamNameChange(this.userId);
      }catch(ex){
        console.log(ex);
      }
    },
    setTeamLeader(personId){
      return this.$store.dispatch('events/setTeamLeader',{
        'person_id':personId
      });
    },
    getTeamInfo(){
      return this.$store.dispatch('events/getTeamInfo',{});
    }
  }
}
